import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Form, Modal } from "react-bootstrap";

export const ConfirmRenameAndShareFlashpackModal = ({
  isVisible,
  initialTitle,
  onSubmit,
  onCancel,
}: {
  isVisible: boolean;
  initialTitle: string;
  onSubmit: (newTitle) => void;
  onCancel: () => void;
}) => {
  const { t } = useTranslation();
  const [tempTitle, setTempTitle] = React.useState(initialTitle);

  // Reset temp title to initial title when the visibility or initial title change:
  // - on initial component render
  // - when the component is shown/hidden
  // - when lesson is renamed and reloaded outside of this component
  React.useEffect(() => setTempTitle(initialTitle), [initialTitle, isVisible]);

  return (
    <Modal show={isVisible} onHide={onCancel}>
      <Modal.Header closeButton>
        <Modal.Title>{t("lesson_details_share_dialog_title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>{t("lesson_details_share_dialog_details")}</div>
        <div className="mt-3">{t("lesson_details_share_dialog_rename")}</div>
        <Form className="mt-3">
          <Form.Group className="mb-3">
            <Form.Control
              placeholder={initialTitle}
              autoFocus
              value={tempTitle}
              onChange={(e) => setTempTitle(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          {t("generic_cancel")}
        </Button>
        <Button
          variant="primary"
          onClick={() => onSubmit(tempTitle)}
          disabled={!tempTitle}
        >
          {t("generic_share")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
